
<template>
    
    <div id="panel-description" class="panel" v-if="members.length > 0">
        <div class="panel-hdr bg-primary-700 bg-success-gradient">
            <h2>
                Учасники
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        <div class="panel-container collapse show overflow-auto">
            <div class="panel-content">
                <div id="protocol_members">
                    <ul class="list-group">
                        <li class="list-group-item  "    :key="member.author_id"  :class="{ 'bg-success text-white': !!member.is_winner }" v-for="member in members">
                            <a :href="'/kontrahenty/' + member.author_id " target="_blank">
                                {{member.company}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    
    <div id="panel-description" class="panel" >
        <div class="panel-hdr bg-primary-700 bg-success-gradient">
            <h2>
                Переможці
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        <div class="panel-container collapse show overflow-auto">
            
            <div class="panel-content">
                <div id="protocol_winners">
                
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "protocol_inside_winners",
    props: { protocol: { type: Object, required: true } },
    
    computed : {
        members () {
            return this.protocol?.members || [];
        }
    }
}
</script>


<style scoped>

</style>